import LsdApiModel from './global/LsdApiModel';

export default class ProjectPoleStatsModel extends LsdApiModel {
	static get path(): string {
		return '/project_poles/stats?expenseGroup={?expenseGroup}';
	}
}
